const batchedCss = [];
let appendAfter = document.head.querySelector("meta[charset]");

export function injectCss(cssContent) {
    if (batchedCss.length === 0) {
        window.queueMicrotask(() => {
            const styleElement = document.createElement("style");
            styleElement.setAttribute("type", "text/css");
            styleElement.appendChild(document.createTextNode(batchedCss.join("")));

            if (appendAfter === null) {
                document.head.prepend(styleElement);
            } else {
                appendAfter.insertAdjacentElement("afterend", styleElement);
            }

            appendAfter = styleElement;
            batchedCss.length = 0;
        });
    }

    batchedCss.push(cssContent);
}
